import { AccessLevel } from "@/api/williams/users";
import { ChangeEvent } from "react";
import { FavoritesView } from "./FavoritesView";
import { getFullPath, routes } from "../routes";
import { HomeView } from "./HomeView";
import { IncompleteView } from "./IncompleteView";
import { OwnedView } from "./OwnedView";
import { Tier2View } from "./Tier2View";
import { useNavigate, useParams } from "react-router-dom";
import { usePermissions } from "../users/hooks";

export function Dashboard() {
  const { view = "favorite" } = useParams();
  const navigate = useNavigate();
  const permissions = usePermissions();

  function handleViewChanged(e: ChangeEvent<HTMLSelectElement>) {
    navigate(getFullPath(routes.dashboard.view(e.target.value)));
  }

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <h3>Dashboard</h3>
        <div className="my-auto">
          <select className="form-select" value={view} onChange={handleViewChanged}>
            {/* <option value="home">Home</option> */}
            <option value="favorite">Favorite</option>
            <option value="incomplete">Incomplete</option>
            <option value="owned">Owned</option>
            {permissions.data && permissions.data.accessLevel >= AccessLevel.WeldingSpecialist && (
              <option value="specialist">Wld/NDE Spec.</option>
            )}
          </select>
        </div>
      </div>

      {view === "home" && <HomeView />}
      {view === "favorite" && <FavoritesView />}
      {view === "incomplete" && <IncompleteView />}
      {view === "owned" && <OwnedView />}
      {view === "specialist" && <Tier2View />}
    </>
  );
}
